import React from "react";

export default function EmptyState({ icon: Icon, title, description, action, testId }) {
  return (
    <div
      className="flex flex-col items-center justify-center text-center py-12 px-6"
      data-testid={testId}
    >
      <div className="relative mb-5">
        <div className="h-16 w-16 rounded-3xl bg-pink-100 flex items-center justify-center">
          {Icon && <Icon className="h-8 w-8 text-pink-500" />}
        </div>
        <span className="absolute -right-1 -top-1 h-4 w-4 rounded-full bg-pink-300" />
        <span className="absolute -left-2 bottom-0 h-3 w-3 rounded-full bg-pink-200" />
      </div>
      <h3 className="font-heading text-lg font-bold text-slate-900">{title}</h3>
      <p className="text-sm text-slate-500 mt-1 max-w-xs">{description}</p>
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
